import { render, staticRenderFns } from "./iphoneYearChange.vue?vue&type=template&id=1a90edda&scoped=true&"
import script from "./iphoneYearChange.vue?vue&type=script&lang=js&"
export * from "./iphoneYearChange.vue?vue&type=script&lang=js&"
import style0 from "./iphoneYearChange.vue?vue&type=style&index=0&id=1a90edda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a90edda",
  null
  
)

export default component.exports